const usageRecord = (store) => ({ install: install(store) });


const install = (store) => (Vue) => {
    const trackRapportage = (binding) => (event) => {
        store.dispatch('trackRapportageEvent', binding.value);
    };
    Vue.directive('ng-usage', {
        bind: function (el, binding, vnode) {
            el.addEventListener(binding.arg, trackRapportage(binding));
        },
        unbind(el, binding) {
            el.removeEventListener(binding.arg, trackRapportage(binding));
        }
    });
};
export default usageRecord;
